import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinimize: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="minimize, window, layout"><path d="M3.75 10.25V3.75H21.25V15.25H14.75M13.75 8.25V11.25H16.75M17 8L14.2527 10.7473M11.25 13.75H2.75V21.25H11.25V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMinimize;
